<template>
  <div class="d-flex align-center">
    <div class="action-icon" id="blocks-trigger">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.3"
        @click="blocksDialog = !blocksDialog"
        height="16.3"
        viewBox="0 0 16.3 16.3"
      >
        <defs></defs>
        <g id="ic_blocks" opacity="0.5" transform="translate(.15 .15)">
          <g id="Group_11646">
            <path
              id="Path_10458"
              d="M6.333 4H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h5.333a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zM1 .667A.333.333 0 0 0 .667 1v2A.333.333 0 0 0 1 3.333h5.333A.333.333 0 0 0 6.667 3V1a.333.333 0 0 0-.334-.333z"
              class="cls-2"
            />
          </g>
          <g id="Group_11647" transform="translate(0 6)">
            <path
              id="Path_10459"
              d="M6.333 13H1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h5.333a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zM1 9.667A.333.333 0 0 0 .667 10v2a.333.333 0 0 0 .333.333h5.333A.333.333 0 0 0 6.667 12v-2a.333.333 0 0 0-.333-.333z"
              class="cls-2"
              transform="translate(0 -9)"
            />
          </g>
          <g id="Group_11648" transform="translate(0 12)">
            <path
              id="Path_10460"
              d="M6.333 22H1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h5.333a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zM1 18.667A.333.333 0 0 0 .667 19v2a.333.333 0 0 0 .333.333h5.333A.333.333 0 0 0 6.667 21v-2a.333.333 0 0 0-.333-.333z"
              class="cls-2"
              transform="translate(0 -18)"
            />
          </g>
          <g id="Group_11649" transform="translate(8.667)">
            <path
              id="Path_10461"
              d="M19.333 16H14a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h5.333a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zM14 .667a.333.333 0 0 0-.333.333v14a.333.333 0 0 0 .333.333h5.333a.333.333 0 0 0 .334-.333V1a.333.333 0 0 0-.333-.333z"
              class="cls-2"
              transform="translate(-13)"
            />
          </g>
        </g>
      </svg>
    </div>
    <div
      class="blocks-input"
      id="blocks-dialog"
      :class="{ 'blocks-input-open': blocksDialog }"
    >
      <div class="blocks-input--search">
        <v-text-field
          v-model="searchKey"
          ref="search"
          outline
          hide-details
          placeholder="Search blocks..."
          prepend-inner-icon="search"
          height="40px"
          @input="searchBlocks()"
        ></v-text-field>
      </div>
      <div class="blocks-input--list">
        <v-layout row wrap>
          <v-flex xs4 v-for="(block, index) in searchedBlocksList" :key="index">
            <p class="blocks-input--list--item" @click="sendBlock(block)">
              {{ block.name }}
            </p>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "inputBlocks",
  data() {
    return {
      searchKey: "",
      blocksList: [],
      searchedBlocksList: [],
      blocksDialog: false,
    };
  },
  async mounted() {
    await this.getBlocksList();
    const clickOutsideBlocks = (e) => {
      if (
        document.getElementById("blocks-dialog") &&
        !document.getElementById("blocks-dialog").contains(e.target) &&
        !document.getElementById("blocks-trigger").contains(e.target)
      ) {
        this.blocksDialog = false;
      }
    };
    document.addEventListener("click", clickOutsideBlocks);
  },
  methods: {
    async getBlocksList() {
      const response = await this.$http_bot.get("/blocks");

      this.blocksList = response.data;
      this.searchedBlocksList = response.data;
    },
    searchBlocks() {
      this.searchedBlocksList = [];
      if (this.searchKey) {
        for (let i = 0; i < this.blocksList.length; i++) {
          if (
            this.blocksList[i].name
              .toLowerCase()
              .includes(this.searchKey.toLowerCase())
          ) {
            this.searchedBlocksList.push(this.blocksList[i]);
          }
        }
      } else {
        this.searchedBlocksList = _.cloneDeep(this.blocksList);
      }
    },
    sendBlock(block) {
      this.blocksDialog = false;
      this.searchKey = "";
      this.searchedBlocksList = _.cloneDeep(this.blocksList);
      this.$emit("sendBlock", block);
    },
  },
};
</script>

<style lang="scss">
.blocks-input {
  background-color: #fdfdfd;
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 15px;
  box-shadow: 0px 0px 14px #0000001a;
  visibility: hidden;
  position: absolute;
  bottom: 55px;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  .v-text-field--outline .v-input__control > .v-input__slot {
    background-color: white !important;
    height: 35px !important;
    border: 1px solid #eee !important;
  }
  .v-text-field.v-text-field--enclosed .v-input__prepend-inner {
    margin-top: 1px;
  }
  &--list {
    height: 180px;
    overflow-y: scroll;
    padding: 15px 5px;
    p {
      color: #aaaaaa;
      font-size: 13px;
      cursor: pointer;
    }
    p:hover {
      color: black;
    }
    &::-webkit-scrollbar {
      width: 0px;
      background: #ddd;
    }

    &::-webkit-scrollbar-track {
      //box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
    }
  }
}
.blocks-input-open {
  visibility: visible;
  opacity: 1;
}

.cls-2 {
  stroke: #000;
  stroke-width: 0.3px;
}
</style>
